module.exports = __webpack_public_path__ + "assets/img/culture_bgimg.8301cfcf.png";